import { api } from '../../../api/axios'
import type { Clube, ClubeFilters, ListResponse } from '../types'

export const clubesService = {
  list: (filters: ClubeFilters = {}) =>
    api.get<ListResponse<Clube>>('/clubes', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Clube }>(`/clubes/${id}`).then(r => r.data.data),

  create: (data: Omit<Clube, 'idclube' | 'data_cadastro'>) =>
    api.post<{ data: Clube }>('/clubes', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Clube, 'idclube' | 'data_cadastro'>>) =>
    api.put<{ data: Clube }>(`/clubes/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/clubes/${id}`),
}
